/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createVendorLinesResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type VendorLinesResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type WithVendorCodeItemRequestBuilder, WithVendorCodeItemRequestBuilderNavigationMetadata, WithVendorCodeItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}/{shoppingCartId}/vendor-lines
 */
export interface VendorLinesRequestBuilder extends BaseRequestBuilder<VendorLinesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.carts.item.item.vendorLines.item collection
     * @param vendorCode The vendor whose line this is ("HAL").
     * @returns {WithVendorCodeItemRequestBuilder}
     */
     byVendorCode(vendorCode: string) : WithVendorCodeItemRequestBuilder;
    /**
     * Returns one line per vendor on the cart with its header, its status (Ready, TermsNeeded, UnderMinimum), subtotal, discount, total and minimum, and the vendor's order types, terms options, fulfillment methods, price levels and ship windows for the pickers. Agency organizations only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<VendorLinesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<VendorLinesRequestBuilderGetQueryParameters> | undefined) : Promise<VendorLinesResponse | undefined>;
    /**
     * Returns one line per vendor on the cart with its header, its status (Ready, TermsNeeded, UnderMinimum), subtotal, discount, total and minimum, and the vendor's order types, terms options, fulfillment methods, price levels and ship windows for the pickers. Agency organizations only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<VendorLinesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns one line per vendor on the cart with its header, its status (Ready, TermsNeeded, UnderMinimum), subtotal, discount, total and minimum, and the vendor's order types, terms options, fulfillment methods, price levels and ship windows for the pickers. Agency organizations only.
 */
export interface VendorLinesRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const VendorLinesRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}/{shoppingCartId}/vendor-lines{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const VendorLinesRequestBuilderNavigationMetadata: Record<Exclude<keyof VendorLinesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byVendorCode: {
        requestsMetadata: WithVendorCodeItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithVendorCodeItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["vendorCode"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const VendorLinesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: VendorLinesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVendorLinesResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
